<template>
  <li class="category-item">
    <p class="title">
      <component
        class="icon"
        :is="icon"
      />
      <span :class="nameClasses">{{ name }}</span>
    </p>
    <PercentageBar
      :percentage="value"
      :strips="strips"
      :alt="alt"
    />
  </li>
</template>

<script>
import PercentageBar from './PercentageBar'

export default {
  name: 'CategoryItem',
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    strips: {
      type: Number,
      required: true
    },
    icon: {
      required: true
    },
    alt: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    nameClasses () {
      return {
        'name': true,
        'white': this.alt
      }
    }
  },
  components: {
    PercentageBar
  }
}
</script>

<style lang="scss" scoped>
.category-item {
  margin: 0 0 22px;
  list-style-type: none;
}

.title {
  padding-left: 20px;
  margin: 0 0 16px;
}

.icon {
  margin-right: 14px;
}

.name,
.icon {
  display: inline-block;
  line-height: 18px;
  vertical-align: middle;
}

.white {
  color: white;
}
</style>
